/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetPackagedOrderPackagesByAWPackageID(awPackageId) {
  const response = await $.soap({
    body: {
      GetPackagedOrderPackagesByAWPackageID: {
        $xmlns: 'http://dla.mil/ems/bpm/order_package',
        AWPackageID: awPackageId
      }
    },
    blueprintArrays: ['GetPackagedOrderPackagesByAWPackageIDResponse.tuple'],
    blueprint: {
      orderPackages: [
        'GetPackagedOrderPackagesByAWPackageIDResponse.tuple',
        {
          id: '$..ID',
          internalOrderStatus: '$..InternalOrderStatus',
          crsFirstName: '$..CRSFirstName',
          crsLastName: '$..CRSLastName',
          formName: '$..FormName',
          orderFormTypeId: '$..OrderFormTypeID',
          createdOn: '$..CreatedOn',
          deviceCount: '$..CalculatedDeviceCount',
          popStartDate: '$..POPDate',
          customerOrderIds: '$..CustomerOrderIDs',
          trackerNumbers: '$..TrackerNumbers'
        }
      ]
    }
  });
  cleanUpResponse(response);

  _.each(response.orderPackages, (orderPackage) => {
    orderPackage.crsName = `${orderPackage.crsFirstName} ${orderPackage.crsLastName}`;
  });

  return response.orderPackages;
}
